import React from 'react'
import CRUD from '../../components/common/CRUD/CRUD'
import { fields } from '../../models/materialResources/stockroomModel'
import { createCRUDService } from '../../services/crudService'
import { Breadcrumb } from 'react-bootstrap'

const StockroomsView = () => {
  const { listItems, deleteItem, createItem, updateItem } = createCRUDService(
    '/api/material_resources/stockrooms'
  )
  return (
    <main style={{ padding: '1rem 0' }}>
      <CRUD
        fields={fields}
        paginated
        entityName='almacén'
        entityNamePlural='Almacenes'
        dataSource={listItems}
        onDelete={deleteItem}
        onCreate={createItem}
        onUpdate={updateItem}
      />
    </main>
  )
}

StockroomsView.breadcrumbs = () => (
  <Breadcrumb.Item key='breadcrumb-stockrooms' href='/stockrooms' active>
    Almacenes
  </Breadcrumb.Item>
)

export default StockroomsView
